module.exports = __webpack_public_path__ + "static/img/file_c.36f322a7.png";